import { render, staticRenderFns } from "./MiddlewareTransactionListComponent.vue?vue&type=template&id=164e04b1&scoped=true"
import script from "./MiddlewareTransactionListComponent.vue?vue&type=script&lang=js"
export * from "./MiddlewareTransactionListComponent.vue?vue&type=script&lang=js"
import style0 from "./MiddlewareTransactionListComponent.vue?vue&type=style&index=0&id=164e04b1&prod&lang=css"
import style1 from "./MiddlewareTransactionListComponent.vue?vue&type=style&index=1&id=164e04b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e04b1",
  null
  
)

export default component.exports